import React, { useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import CreateEditViewBilling from "../../components/invoice-section/create-edit-view-billing";
import { useDispatch } from "react-redux";
import { invoiceViewAction } from "../../redux/actions/invoices-action";
import { useParams } from "react-router-dom";

const ViewBilling = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [invoice, setInvoice] = useState({});
  const [loading, setLoading] = useState(true);
  const fetchInvoice = () => dispatch(invoiceViewAction(id, onSuccess, onError));
  useEffect(() => {
    fetchInvoice();
  }, []);
  const onSuccess = (data) => {
    setLoading(false);
    setInvoice(data?.data?.[0]);
  };
  const onError = (data) => {
    setLoading(false);
  };
  return (
    <InnerLayout backBtn={true} title="View Billing">
      <CreateEditViewBilling
        loading={loading}
        setLoading={setLoading}
        page="view"
        invoice={invoice}
        disabled={true}
        onBillUpdated={fetchInvoice}
      />
    </InnerLayout>
  );
};

export default ViewBilling;
